import { render } from "./dropdown-hotel-name.vue?vue&type=template&id=6a1a6963"
import script from "./dropdown-hotel-name.vue?vue&type=script&lang=js"
export * from "./dropdown-hotel-name.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__